module.exports = __webpack_public_path__ + "media/images/pic/products/lopatka-8566ecd949c04750e56490f224b9b193.jpg";